import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	showMoreButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	label: {
		id: 'software-filters.filters.assignee.stateless.label',
		defaultMessage: 'Filter by assignee',
		description:
			'The legend of a fieldset used to display an avatar of each team members to filter issues by.',
	},
	showMoreButton: {
		id: 'software-filters.filters.assignee.stateless.show-more',
		defaultMessage: 'Show more assignees',
		description: 'The aria label for the view more button to show more assignees.',
	},
});
export default messages;
